import BottomSheet from "@components/Popup/BottomSheet";
import Frame from "@components/Popup/Frame";
import {useTranslation} from "@i18n/client";
import React, {useMemo} from "react";
import {useSexAtBirthText} from "src/hooks/booking/useSexAtBirthText";
import {I18nNamespace} from "@i18n";

type Props = {
  close: () => void;
  isOpen: boolean;
};

const SexAtBirthBottomSheet: React.FC<Props> = ({close, isOpen}) => {
  const {t} = useTranslation(I18nNamespace.WEB_SCHEDULING);
  const sexAtBirthText = useSexAtBirthText();

  const title = useMemo(
    () => (
      <h1 className="font-i text-2xl font-semibold text-gray-1000 self-center">
        {t("Sex Assigned at Birth", {ns: "web-scheduling"})}
      </h1>
    ),
    [t],
  );

  return (
    <BottomSheet open={isOpen} onClose={close}>
      <Frame title={title} onClose={close}>
        <p className="font-i pb-6">{sexAtBirthText}</p>
      </Frame>
    </BottomSheet>
  );
};

export default React.memo(SexAtBirthBottomSheet);
